var _circle, _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIcoSucess(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 124,
    height: 124,
    viewBox: "0 0 124 124",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 62,
    cy: 62,
    r: 62,
    fill: "#00D9D6"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M69.659 44.811C65.9523 43.1594 61.8111 42.7502 57.8528 43.6445C53.8946 44.5388 50.3315 46.6887 47.6949 49.7734C45.0584 52.8582 43.4896 56.7126 43.2226 60.7618C42.9556 64.811 44.0047 68.8381 46.2134 72.2423C48.422 75.6466 51.672 78.2457 55.4785 79.652C59.285 81.0583 63.4442 81.1965 67.3356 80.0459C71.2271 78.8953 74.6424 76.5177 77.0721 73.2675C79.5018 70.0173 80.8159 66.0688 80.8182 62.0108V60.0883C80.8182 58.9335 81.7543 57.9974 82.9091 57.9974C84.0639 57.9974 85 58.9335 85 60.0883V62.012C84.9972 66.9717 83.3911 71.7989 80.4215 75.7713C77.4518 79.7438 73.2775 82.6498 68.5213 84.0561C63.7651 85.4624 58.6817 85.2935 54.0293 83.5747C49.3769 81.8559 45.4047 78.6792 42.7052 74.5184C40.0057 70.3576 38.7235 65.4357 39.0499 60.4867C39.3762 55.5377 41.2936 50.8267 44.516 47.0564C47.7385 43.2861 52.0934 40.6585 56.9312 39.5655C61.7691 38.4725 66.8306 38.9725 71.361 40.9912C72.4158 41.4612 72.8899 42.6973 72.4199 43.7521C71.9499 44.8069 70.7138 45.2809 69.659 44.811Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M84.3744 44.5846C85.2079 45.3646 85.2086 46.6299 84.3759 47.4107L63.0426 67.414C62.6426 67.7891 62.0998 67.9999 61.5339 68C60.9679 68.0001 60.425 67.7896 60.0248 67.4147L53.6248 61.4197C52.7917 60.6393 52.7917 59.374 53.6248 58.5936C54.458 57.8132 55.8087 57.8132 56.6418 58.5936L61.5326 63.1749L81.3574 44.586C82.1901 43.8052 83.5409 43.8046 84.3744 44.5846Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcoSucess);
export default __webpack_public_path__ + "static/media/ico_sucess.b099cc46726ca4043a76cc87d5ef29d6.svg";
export { ForwardRef as ReactComponent };